import { Country } from '../interfaces/Country';
import { Autocomplete, CircularProgress, MenuItem } from '@mui/material';
import { Fragment } from 'react';
import CustomTextField from './CustomTextInput';
import useCountries from '../customhooks/useCountries';

interface CountryAutocompleteProps {
    onHandleChange: (value: Country) => void;
    initialValue?: string;
    error?: boolean;
    errorMessage?: string;
    label?: string;
    helperText?: string;
}

const CountrySelect = (props: CountryAutocompleteProps) => {
    const { countries, isCountriesLoading } = useCountries();

    return (
        <Autocomplete
            placeholder='Country'
            disableClearable
            renderInput={(params) => (
                <CustomTextField
                    name='country'
                    params={params}
                    label={props?.label ?? 'Select Country'}
                    placeholder='Country'
                    helperText={props.helperText}
                    error={props.error}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: isCountriesLoading && (
                            <Fragment>
                                <CircularProgress size={20} />
                                {params.InputProps.endAdornment}
                            </Fragment>
                        )
                    }}
                />
            )}
            noOptionsText={'No data available'}
            renderOption={(props, option) => (
                <MenuItem
                    {...props}
                    value={option.name}
                    key={`countries-${option.id}`}
                    className='flex gap-2 items-center'
                >
                    <img
                        src={option?.flagImageUrl}
                        alt={`${option.name}-flag`}
                        className='w-4 h-4'
                    />{' '}
                    {option.name}
                </MenuItem>
            )}
            getOptionLabel={(option) => option.name || ''}
            onChange={(_, value) => props.onHandleChange(value)}
            options={countries}
        />
    );
};

export default CountrySelect;
